import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Modal, Button } from "@/components";
import styles from "./SuccessCreateGameModal.module.scss";
import successCreateGameImage from "@/assets/img/success-create-game-image.png";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

interface SuccessCreateGameModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const TITLE = "Игра успешно создана!";
const SUBTITLE =
  "Когда будут откликаться пользователи, Вам будут приходить уведомления на почту, указанную в профиле. Посмотреть контакты откликнувшихся пользователей можно в Вашей игре.";

const SuccessCreateGameModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessCreateGameModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const handleClose = () => {
    closeModal();
    navigate("/padel/games/my");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Modal
      title={TITLE}
      subTitle={SUBTITLE}
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      noBorder
    >
      <div className={styles.content}>
        <img
          src={successCreateGameImage}
          alt="success create game"
          className={styles.image}
        />
        {isMobile && (
          <div className={styles.mobileContent}>
            <span className={styles.mobileTitle}>{TITLE}</span>
            <span className={styles.mobileSubTitle}>{SUBTITLE}</span>
          </div>
        )}
        <Button onClickFunc={handleClose} newStyles={styles.button}>
          Перейти в "Мои игры"
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessCreateGameModalComponent;
export const SuccessCreateGameModal = SuccessCreateGameModalComponent;
